// extracted by mini-css-extract-plugin
export default {"container":"sidePanel-module--container--fGymD"};